var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-legend",class:{'circle-legend': _vm.centerClass}},[_c('h4',{style:({ marginLeft: _vm.offSet})},[_vm._v(" Wind Speed (Miles per Hour)")]),_vm._v(" "),_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"id":_vm.field,"width":_vm.width,"transform":"translate(20,15)"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ddb5868","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CircleLegend.vue
// module id = wXSp
// module chunks = 1